import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Footer from "../../components/Footer/footer";
import HeaderComponent from "../../components/Header";
import "../../static/css/styles.css";
import { Spring } from "react-spring";
import CounsellorPublicListCard from "./CounsellorPublicListCard";
import { slotActions, authActions, WhitelabelActions } from "../../store/actions";
import SaayaLogo from "../../static/images/saaya-logo-new.png";
import { b2cURL } from "../../config";
import Loading from "../../components/Loading/Loading";
import { history } from "../../helpers/history";
import { getCountryName } from "../../helpers/utils";
import { constants } from "../../Constants";

class ListOfCounsellors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryName: null,
      counsellor_loading: false
    };
  }

  // Get country name
  getCountryDetails = async () => {
    this.setState({ countryName: await getCountryName() });
  };

  componentWillReceiveProps(nextProps){
    if(nextProps.whitelabel && nextProps.whitelabel.length > 0){
      if(this.state.counsellor_loading === false) {
        this.setState({ counsellor_loading: true }, () => {
          this.props.fetchPublicCounsellorList();
        })
      }
    }
  }

  componentDidMount() {
    this.props.fetchWhitelabel();
    if (!this.state.countryName) this.getCountryDetails();
  }

  createAppointment = () => {
    window.location.href = b2cURL;
  };

  render() {
    const { whitelabel } = this.props;
    const project_id = localStorage.getItem("project_id")
    return (
      <div className="sh-layout">
        <div className="sh-header-comp">
            <div className="sh-header-inner">
              <div className="sh-header-left">
                <div className="sh-hl-logo">
                  <img
                    src={whitelabel ? whitelabel[0].logo_url : SaayaLogo}
                    alt="SaayaLogo"
                    onClick={this.home}
                  />
                </div>
              </div>
            </div>
          </div>
        <div className="sh-counsellor-list-comp sh-gnrl-width">
          {/* Welcome Note */}
          <div className="sh-gnrl-welcome-note">
            <h2 className="sh-gnrl-welcome" id="">
              {"CHOOSE YOUR COUNSELLOR"}
            </h2>
          </div>

          <div className="sh-counsellor-list">
            <div className="inner-list">
              {this.props.state.slots.list ? (
                this.props.state.slots.list &&
                this.props.state.slots.list.length > 0 ? (
                  this.props.state.slots.list.map((v, i) => {
                    return (
                      <div className="grid-col">
                        <CounsellorPublicListCard
                          countryNameState={
                            this.state.countryName && this.state.countryName
                          }
                          whitelabel={whitelabel && whitelabel[0]}
                          v={v}
                          id={i}
                          key={i}
                          createAppointment={() =>
                            this.createAppointment(v.counsellor_id)
                          }
                        />
                      </div>
                    );
                  })
                ) : (
                  <React.Fragment>
                    <div className="grid-col"></div>
                    <div className="grid-col" style={{ textAlign: "center" }}>
                      No{" "}
                      {whitelabel && whitelabel[0]
                        ? whitelabel[0].producer_role.toLowerCase()
                        : constants.COUNSELLOR.toLowerCase()}{" "}
                      available for now
                    </div>
                  </React.Fragment>
                )
              ) : (
                <Loading />
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authstate, user } = state.auth;
  const { whitelabel } = state.whitelabel;
  return {
    alert,
    authstate,
    whitelabel,
    user,
    state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPublicCounsellorList: () => {
      dispatch(slotActions.fetchPublicCounsellorList());
    },
    fetchWhitelabel: () => {
        dispatch(WhitelabelActions.fetchWhitelabel());
      }
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListOfCounsellors)
);



// WEBPACK FOOTER //
// ./src/screens/CounsellorPublicList/index.js